// extracted by mini-css-extract-plugin
module.exports = {"cartItem_imageContainer":"cart_item_cartItem_imageContainer__TE2_N"};